module.exports = __webpack_public_path__ + "img/layout_triangle_icon.8beb9ac7.svg";